export const UploadOrdersFileActions = {
	UPLOAD: 'UPLOAD',
	PROCESSING: 'PROCESSING',
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
	FILE_ERRORS: 'FILE_ERRORS',
};

export const ShippingOptions = {
	FULFILLED: 'FULFILLED',
	PENDING: 'PENDING',
	PROCESSING: 'PROCESSING',
	RETURNED: 'RETURNED',
	CANCELLED: 'CANCELLED',
};

export const OrderStatus = {
	ORDER_PLACED: { label: 'Order Placed', color: '#B8E8F2' },
	ACCEPTED: { label: 'Accepted', color: '#B8E8F2' },
	PENDING: { label: 'Pending', color: '#FADE8E' },
	PROCESSING: { label: 'Processing', color: '#FADE8E' },
	PARTIALLY_FULFILLED: { label: 'Partially Fulfilled', color: '#F6D69E' },
	FULFILLED: { label: 'Fulfilled', color: '#C0F4BE' },
	SHIPPED: { label: 'Shipped', color: '#C0F4BE' },
	COMPLETED: { label: 'Completed', color: '#C0F4BE' },
	CANCELLED: { label: 'Cancelled', color: '#D15A64' },
	RETURNED: { label: 'Returned', color: '#A31824' },
};

export const getOrderStatusLabel = (status) => {
	if(!status){
		return OrderStatus.ORDER_PLACED.label;
	}else if (Object.keys(OrderStatus).includes(status.toUpperCase())) {
		return OrderStatus[status.toUpperCase()].label;
	}
	return status;
};

export const getOrderStatusColor = (status) => {
	if(!status){
		return OrderStatus.ORDER_PLACED.color;
	}else if (Object.keys(OrderStatus).includes(status.toUpperCase())) {
		return OrderStatus[status.toUpperCase()].color;
	}
	return '#E9F3F7';
};
